import {alertActionTypes} from '../_constants';

/**
 * Alert redux reducer that sets appropriate message based on dispatch from redux actions
 * @param state
 * @param action
 * @returns {{type: string, message: *}|{}|{type: string, message: *}}
 */
export function alert(state = {}, action) {

  switch (action.type) {

    case alertActionTypes.SUCCESS:
      return {
        type: alertActionTypes.SUCCESS,
        message: action.message
      };

    case alertActionTypes.ERROR:
      return {
        type: alertActionTypes.ERROR,
        message: action.message
      };

    case alertActionTypes.CLEAR:
      return {};

    default:
      return state
  }
}